import React, { useState } from 'react';
import { Panel } from 'react-bootstrap';
import { Button } from '../../../../../common/components';
import FaPlus from 'react-icons/lib/fa/plus';
import FaMinus from 'react-icons/lib/fa/minus';
import './DocumentCollapsePanel.scss';

const DocumentCollapsePanel = ({ documents, headerName, panelKey }) => {
  const [show, setShow] = useState();

  const toggleDocuments = () => {
    setShow(!show);
  };

  if (!documents) {
    return null;
  }

  return (
    <Panel eventKey={panelKey}>
      <Panel.Heading
        className={'document-collapse-panel--heading'}
        onClick={toggleDocuments}
      >
        {headerName}
        {show ? <FaMinus /> : <FaPlus />}
      </Panel.Heading>
      {show && (
        <Panel.Body>
          <div className="documents">
            {documents.map((document) => {
              const path = document.path;
              return (
                <a key={document.id} href={document.path} target="_blank">
                  <Button size="sm" label={document.name} />
                </a>
              );
            })}
          </div>
        </Panel.Body>
      )}
    </Panel>
  );
};

export default DocumentCollapsePanel;
